export default {
  index() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses');
  },

  addressesBy(person) {
    if (person) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addressesbyperson/' + person + '?list');
    }

    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addressesbyowner/' + JSON.parse(localStorage.getItem('person')).id + '?list');
  },

  store(address) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/persons/addresses', { address: address });
  },
  show(id) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
  },
  update(address) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + address.id, { address: address });
  },
  destroy(id) {
    return axios.delete(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
  },

  searchByPostalCode(postalCode) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/address/postal-code/search?postal_code=' + postalCode);
  },
};
